import { c as _c } from "react/compiler-runtime";
import { HeaderLayoutCenter } from "@components/page-layout/header/header-layout-center";
import { HeaderLayoutLeft } from "@components/page-layout/header/header-layout-left";
import { HeaderLayoutRight } from "@components/page-layout/header/header-layout-right";
import { Searchbar } from "@components/header/searchbar";
import { AppBar } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { usePreservedSearch } from "@hooks/use-preserved-search";
import { useRouteMatch } from "@hooks/use-route-match";
import { PALETTE_VARS } from "@styles/palette-vars";
import { Box } from "@mui-wrapper";
import { generateProjectsRoute, useAppParams } from "@router/router-helper";
import { SidebarEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useNavigate } from "react-router-dom";
/** Content of the app header */
export function AppHeader(t0) {
  const $ = _c(31);
  const {
    shouldShowLogo: t1,
    topLeftHeaderButton,
    shouldHideOpenButton: t2,
    shouldShowSidebar: t3,
    centerComponent,
    shouldShowProgressOverviewMenu: t4,
    shouldShowUserMenu: t5,
    shouldShowBreadcrumbs: t6
  } = t0;
  const shouldShowLogo = t1 === undefined ? false : t1;
  const shouldHideOpenButton = t2 === undefined ? false : t2;
  const shouldShowSidebar = t3 === undefined ? true : t3;
  const shouldShowProgressOverviewMenu = t4 === undefined ? true : t4;
  const shouldShowUserMenu = t5 === undefined ? true : t5;
  const shouldShowBreadcrumbs = t6 === undefined ? true : t6;
  const navigate = useNavigate();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    companyId
  } = useAppParams();
  let t7;
  if ($[0] !== companyId) {
    t7 = companyId ? generateProjectsRoute(companyId) : "/";
    $[0] = companyId;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const home = usePreservedSearch(t7);
  const {
    isScreenXs
  } = useMediaQueryList();
  const isWorkspacesRoute = useRouteMatch() === "workspaces";
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: "100%",
      position: "sticky",
      top: 0,
      zIndex: 2
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const t9 = `${home.pathname}${home.search}`;
  let t10;
  if ($[3] !== home || $[4] !== navigate || $[5] !== trackEvent) {
    t10 = () => {
      trackEvent({
        name: SidebarEvents.goHome
      });
      navigate(home);
    };
    $[3] = home;
    $[4] = navigate;
    $[5] = trackEvent;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== shouldHideOpenButton || $[8] !== shouldShowBreadcrumbs || $[9] !== shouldShowSidebar || $[10] !== topLeftHeaderButton) {
    t11 = <HeaderLayoutLeft shouldHideOpenButton={shouldHideOpenButton} topLeftHeaderButton={topLeftHeaderButton} shouldShowSidebar={shouldShowSidebar} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />;
    $[7] = shouldHideOpenButton;
    $[8] = shouldShowBreadcrumbs;
    $[9] = shouldShowSidebar;
    $[10] = topLeftHeaderButton;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== centerComponent) {
    t12 = <HeaderLayoutCenter centerComponent={centerComponent} />;
    $[12] = centerComponent;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = isWorkspacesRoute && !isScreenXs;
  let t14;
  if ($[14] !== shouldShowProgressOverviewMenu || $[15] !== shouldShowUserMenu || $[16] !== t13) {
    t14 = <HeaderLayoutRight shouldShowProgressOverviewMenu={shouldShowProgressOverviewMenu} shouldShowUserMenu={shouldShowUserMenu} shouldShowSearchbar={t13} />;
    $[14] = shouldShowProgressOverviewMenu;
    $[15] = shouldShowUserMenu;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== shouldShowLogo || $[19] !== t10 || $[20] !== t11 || $[21] !== t12 || $[22] !== t14 || $[23] !== t9) {
    t15 = <AppBar shouldShowLogo={shouldShowLogo} logoUrl={t9} onLogoClick={t10}>{t11}{t12}{t14}</AppBar>;
    $[18] = shouldShowLogo;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t14;
    $[23] = t9;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== isScreenXs || $[26] !== isWorkspacesRoute) {
    t16 = isWorkspacesRoute && isScreenXs && <Box sx={{
      px: 2,
      py: 1,
      backgroundColor: "surfaces.primary",
      borderBottom: `1px solid ${PALETTE_VARS.divider}`
    }}><Searchbar variant="filled" shouldFullWidth={true} /></Box>;
    $[25] = isScreenXs;
    $[26] = isWorkspacesRoute;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15 || $[29] !== t16) {
    t17 = <Box sx={t8} data-testid="HEADER_CONTAINER">{t15}{t16}</Box>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
}